import React, { useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';

import '../../App.css';
import { useTranslation } from 'react-i18next';

// icons

// types
import {
  DataItemType,
  RucioLocationsType,
  SiteStorageArea,
  Site,
} from '../../utils/types';
import { SelectedRowsType } from './search-catalog-types';

// enum
import { SidePanelPosition } from '../../tools/side-panel';

// functions

// classes
import SidePanel from '../../tools/side-panel';
import DataStagingComponent from '../data-management/data-staging-component';

//	--------------------------------------------------------------------------
//
//	R E D U X   S T A T E   M A N A G E M E N T
//
//	--------------------------------------------------------------------------

// import state definition and functions.
import { rD_updateRucioLocations } from '../../app/data-slice';
import {
  setContextMenuRefreshStageData,
  setSelectedItemsPanelMaximised,
} from './search-catalog-slice';
import { CONTEXT_SYSTEMS } from '../menus/context-menu-slice';
import { getRucioSites } from '../data-management/file-browser-actions';

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

export default function SelectedItemsPanel() {
  //
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  const dispatch = useAppDispatch();

  // rucio locations.
  const sD_rucioLocations: RucioLocationsType[] = useAppSelector(
    (state) => state.data.rucioLocations,
  );

  // LOCAL STATE VARIABLES:

  // then we have a list of selected files, with lists of available and moving sites attached.
  const sSelectedItemsPanelMaximised: boolean = useAppSelector(
    (state) => state.searchCatalog.selectedItemsPanelMaximised,
  );

  // maintain the state for the selected rows on the results tabs.
  const sSelectedRows: SelectedRowsType[] = useAppSelector(
    (state) => state.searchCatalog.selectedItems.selectedRows,
  );

  //	--------------------------------------------------------------------------
  //
  //	D E C L A R A T I O N S
  //
  //	--------------------------------------------------------------------------

  // translation function
  const { i18n, t } = useTranslation();

  const sSelectedItems: DataItemType[] = sSelectedRows.map((row) => {
    return {
      namespace: row.namespace,
      filename: row.filename,
    };
  });

  //	--------------------------------------------------------------------------
  //
  //	E V E N T   D E C L A R A T I O N S
  //
  //	--------------------------------------------------------------------------

  //	--------------------------------------------------------------------------
  //
  //	F U N C T I O N S
  //
  //	--------------------------------------------------------------------------

  //	------------------------------------------------------------
  //
  //	Handler for button onClick events.
  //
  //	------------------------------------------------------------

  const onClickButtonHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    //
    const button: HTMLButtonElement = event.currentTarget;

    // minimise/maximise the filter box if the user clicks minimise/maximise.
    if (button.name === 'minimiseFilter') {
      dispatch(setSelectedItemsPanelMaximised(false));
    }
    if (button.name === 'maximiseFilter') {
      dispatch(setSelectedItemsPanelMaximised(true));
    }

    // refresh the available sites.
    if (button.name === 'refresh-panel') {
      refreshSites();
    }
    //
  }; // onClickButtonHandler

  //	-------------------------------------------------
  //
  //	refresh the list of available sites and moving
  //	sites for each data item.
  //
  //	-------------------------------------------------

  function refreshSites() {
    //
    // store the required changes in a new array.
    const updatedLocationsChanges: {
      namespace: string;
      filename: string;
      refresh: boolean | null;
    }[] = sD_rucioLocations
      .filter((filter) => filter.catalog.indexOf('search-catalog') > -1)
      .map((item) => {
        return {
          namespace: item.namespace,
          filename: item.filename,
          refresh: true,
        };
      });

    // update the locations state so that all the refresh flags are false.
    if (updatedLocationsChanges.length > 0) {
      dispatch(
        rD_updateRucioLocations({
          items: updatedLocationsChanges,
        }),
      );
    }
    //
  } // refreshSites

  //	--------------------------------------------------------------------------
  //
  //	H O O K S
  //
  //	--------------------------------------------------------------------------

  //	--------------------------------------------------------------------------
  //
  //	C O M P O N E N T   C O D E
  //
  //	--------------------------------------------------------------------------

  return (
    <SidePanel
      position={SidePanelPosition.RIGHT}
      title={t('Selected items')}
      maximised={sSelectedItemsPanelMaximised}
      setMaximised={setSelectedItemsPanelMaximised}
      redux={true}
      width={'100%'}
      height="100%"
      padding={'0px 0px 0px 0px'}
    >
      <div
        className="select-items-container"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'end',
        }}
        data-collapsed={sSelectedItemsPanelMaximised ? 'F' : 'T'}
        data-selected-items={sD_rucioLocations.length > 0 ? 'T' : 'F'}
      >
        <div
          className="text-colour"
          style={{
            flex: '0 0 auto',
            margin: '15px 10px 10px 0px',
            fontSize: '1.2em',
          }}
        >
          {sSelectedItems.length === 1
            ? sSelectedItems[0].filename
            : (sSelectedItems.length?.toString() ?? 0) + ' items selected'}
        </div>
        <DataStagingComponent
          allItems={sSelectedItems}
          selectedItems={sSelectedItems}
          catalog="search-catalog"
          contextSystem={CONTEXT_SYSTEMS.SEARCH_CATALOG_SELECTED_ITEMS}
          contextMenuRefresh={setContextMenuRefreshStageData}
          hideItemCount={true}
          showComputeSessions={true}
        />
      </div>
    </SidePanel>
  );
} // SelectedItemsPanel
